import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { colors, SovosFlatButton } from 's1-ui';
import OrangeAddCircle from 'commonComponents/orangeAddCircle';

const {
  primaryNavy, neutralWhite, grayDark
} = colors;

const styles = {
  pageContainer: {
    backgroundColor: primaryNavy,
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  carrierText: {
    color: neutralWhite,
    fontSize: 35,
    fontWeight: 100,
    paddingTop: 200
  },
  addInfo: {
    color: neutralWhite,
    fontSize: 20,
    fontWeight: 100,
    paddingTop: 30,
    paddingBottom: 40
  },
  existingContainer: {
    width: 450,
    backgroundColor: grayDark,
    color: neutralWhite,
    padding: 20
  },
  existingContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  existingText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingLeft: 40
  },
  text1: {
    fontSize: 22,
    fontWeight: 300
  },
  text2: {
    fontSize: 16,
    fontWeight: 300
  },
  newAccountContainer: {
    width: 450,
    backgroundColor: grayDark,
    color: neutralWhite,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 20

  },
  button: {
    maxHeight: 120,
    textTransform: 'none'
  },
  newAccountText: {
    fontSize: 22,
    fontWeight: 300,
    paddingLeft: 40
  },
  iconRoot: {
    fontSize: 50
  }
};

export const UnstyledWhereToAdd = ({
  classes
}) => (
  <div className={ `CCP__WhereToAdd__Container ${classes.pageContainer}` }>
    <div className={ classes.carrierText }>
      Where do you want to add Carrier Compliance information?
    </div>
    <div className={ classes.addInfo }>
      Add info to an existing account or create a new Carrier Compliance account
    </div>
    <div>
      <SovosFlatButton
        classes={ { root: classes.button } }
      >
        <div className={ classes.existingContainer }>
          <div className={ classes.existingContent }>
            <div className={ classes.existingText }>
              <div className={ classes.text1 }>Existing ShipCompliant account</div>
              <div className={ classes.text2 }># existing accounts detected</div>
            </div>
          </div>
        </div>
      </SovosFlatButton>
    </div>
    <div style={ { paddingTop: 20 } }>
      <SovosFlatButton
        classes={ { root: classes.button } }
      >
        <div className={ classes.newAccountContainer }>
          <div className={ classes.buttonIcon }>
            <OrangeAddCircle
              color="primary"
              classes={ { root: classes.iconRoot } }
            />
          </div>
          <div className={ classes.newAccountText }>
            Create a new account
          </div>
        </div>
      </SovosFlatButton>
    </div>
  </div>
);

UnstyledWhereToAdd.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(UnstyledWhereToAdd);
